import { components } from '@doltech/pageManagement/dto';
import { getEnumSampleChartTypeTextByKey } from '@doltech/utils/lib/enum/SampleChartTypeEnum';
import { getSampleDocumentTypeEnumTextByKey } from '@doltech/utils/lib/enum/SampleDocumentTypeEnum';
import { getSampleQuestionTypeEnumTextByKey } from '@doltech/utils/lib/enum/SampleQuestionTypeEnum';
import * as React from 'react';

import { SampleCard, SampleCardProps } from './SampleCard';

interface WritingSampleCardProps extends SampleCardProps {
  data: components['schemas']['WritingSampleDTO'];
}

export const WritingSampleCard = (props: WritingSampleCardProps) => {
  const { data } = props;
  const { chartType, questionType, documentType, description, year, quarter } = data;

  let type = '';
  if (chartType) {
    type = getEnumSampleChartTypeTextByKey(chartType);
  }
  if (questionType) {
    type = getSampleQuestionTypeEnumTextByKey(questionType);
  }
  if (documentType) {
    type = getSampleDocumentTypeEnumTextByKey(documentType);
  }

  const metadata = [
    {
      id: 'QUARTER',
      text: quarter && year && `Quí ${quarter} ${year}`,
    },
    type && {
      id: 'TYPE',
      text: type,
    },
  ].filter(Boolean);

  return <SampleCard metadata={metadata} description={description} {...props} />;
};
